import { render, staticRenderFns } from "./BlwIllustration.vue?vue&type=template&id=7fa96382&"
import script from "./BlwIllustration.vue?vue&type=script&lang=js&"
export * from "./BlwIllustration.vue?vue&type=script&lang=js&"
import style0 from "./BlwIllustration.vue?vue&type=style&index=0&id=7fa96382&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports